package features.members.handlers

import kotlinx.browser.window
import shared.ui.ModalManager

/**
 * Test dummy export with sample data to validate Excel template structure
 * This function creates an Excel file with:
 * - Multiple sheets (one per month)
 * - Merged cells for member grouping
 * - Sub-rows for attendance, overtime, and timeoff
 */
fun testDummyExport() {
    console.log("========================================")
    console.log("📊 TEST DUMMY EXPORT V3 - SECTION BASED")
    console.log("========================================")
    
    val monthName = "Jan-2026"
    val data = js("[]")
    
    // ========== MEMBER 1: Godirs (BANYAK DATA) ==========
    // Member Header Row
    val m1Header = js("[]")
    m1Header.push("Godirs")
    m1Header.push("godirs@example.com")
    m1Header.push("Owner")
    data.push(m1Header)
    
    // --- TIME OFF SECTION ---
    val m1TimeOffHeader = js("[]")
    m1TimeOffHeader.push("✈️ TIME OFF")
    m1TimeOffHeader.push("Date")
    m1TimeOffHeader.push("Period")
    m1TimeOffHeader.push("Days")
    m1TimeOffHeader.push("Status")
    m1TimeOffHeader.push("Category")
    data.push(m1TimeOffHeader)
    
    val m1To1 = js("[]")
    m1To1.push("")
    m1To1.push("2026-01-15")
    m1To1.push("2026-01-15 to 2026-01-17")
    m1To1.push("3 days")
    m1To1.push("Approved")
    m1To1.push("Annual Leave")
    data.push(m1To1)
    
    val m1To2 = js("[]")
    m1To2.push("")
    m1To2.push("2026-01-25")
    m1To2.push("2026-01-25 to 2026-01-26")
    m1To2.push("2 days")
    m1To2.push("Pending")
    m1To2.push("Personal")
    data.push(m1To2)
    
    // --- OVERTIME SECTION ---
    val m1OvertimeHeader = js("[]")
    m1OvertimeHeader.push("⏱️ OVERTIME")
    m1OvertimeHeader.push("Date")
    m1OvertimeHeader.push("Start Time")
    m1OvertimeHeader.push("End Time")
    m1OvertimeHeader.push("Hours")
    m1OvertimeHeader.push("Status")
    m1OvertimeHeader.push("Reason")
    data.push(m1OvertimeHeader)
    
    val m1Ot1 = js("[]")
    m1Ot1.push("")
    m1Ot1.push("2026-01-10")
    m1Ot1.push("18:00")
    m1Ot1.push("20:00")
    m1Ot1.push("2.0h")
    m1Ot1.push("Approved")
    m1Ot1.push("Project deadline")
    data.push(m1Ot1)
    
    val m1Ot2 = js("[]")
    m1Ot2.push("")
    m1Ot2.push("2026-01-18")
    m1Ot2.push("17:30")
    m1Ot2.push("19:30")
    m1Ot2.push("2.0h")
    m1Ot2.push("Approved")
    m1Ot2.push("Client meeting")
    data.push(m1Ot2)
    
    val m1Ot3 = js("[]")
    m1Ot3.push("")
    m1Ot3.push("2026-01-28")
    m1Ot3.push("18:00")
    m1Ot3.push("21:00")
    m1Ot3.push("3.0h")
    m1Ot3.push("Pending")
    m1Ot3.push("Bug fixing")
    data.push(m1Ot3)
    
    // --- ATTENDANCE SECTION ---
    val m1AttHeader = js("[]")
    m1AttHeader.push("📅 ATTENDANCE")
    m1AttHeader.push("Date")
    m1AttHeader.push("Check In")
    m1AttHeader.push("Check Out")
    m1AttHeader.push("Hours")
    m1AttHeader.push("Status")
    m1AttHeader.push("Location")
    data.push(m1AttHeader)
    
    val m1Att1 = js("[]")
    m1Att1.push("")
    m1Att1.push("2026-01-02")
    m1Att1.push("08:30")
    m1Att1.push("17:00")
    m1Att1.push("8.5h")
    m1Att1.push("Present")
    m1Att1.push("GPS Location")
    data.push(m1Att1)
    
    val m1Att2 = js("[]")
    m1Att2.push("")
    m1Att2.push("2026-01-03")
    m1Att2.push("08:45")
    m1Att2.push("17:15")
    m1Att2.push("8.5h")
    m1Att2.push("Present")
    m1Att2.push("GPS Location")
    data.push(m1Att2)
    
    val m1Att3 = js("[]")
    m1Att3.push("")
    m1Att3.push("2026-01-06")
    m1Att3.push("09:00")
    m1Att3.push("17:00")
    m1Att3.push("8.0h")
    m1Att3.push("Late")
    m1Att3.push("GPS Location")
    data.push(m1Att3)
    
    val m1Att4 = js("[]")
    m1Att4.push("")
    m1Att4.push("2026-01-29")
    m1Att4.push("14:42")
    m1Att4.push("-")
    m1Att4.push("-")
    m1Att4.push("Present")
    m1Att4.push("GPS Location")
    data.push(m1Att4)
    
    val m1Att5 = js("[]")
    m1Att5.push("")
    m1Att5.push("2026-01-30")
    m1Att5.push("15:20")
    m1Att5.push("-")
    m1Att5.push("-")
    m1Att5.push("Present")
    m1Att5.push("GPS Location")
    data.push(m1Att5)
    
    // Empty row separator
    data.push(js("[]"))
    
    // ========== MEMBER 2: Muslikhul Adib (1 DATA SAJA) ==========
    val m2Header = js("[]")
    m2Header.push("Muslikhul Adib")
    m2Header.push("adib@example.com")
    m2Header.push("Admin")
    data.push(m2Header)
    
    // Only Attendance (no timeoff/overtime)
    val m2AttHeader = js("[]")
    m2AttHeader.push("📅 ATTENDANCE")
    m2AttHeader.push("Date")
    m2AttHeader.push("Check In")
    m2AttHeader.push("Check Out")
    m2AttHeader.push("Hours")
    m2AttHeader.push("Status")
    m2AttHeader.push("Location")
    data.push(m2AttHeader)
    
    val m2Att1 = js("[]")
    m2Att1.push("")
    m2Att1.push("2026-01-02")
    m2Att1.push("18:04")
    m2Att1.push("-")
    m2Att1.push("-")
    m2Att1.push("Present")
    m2Att1.push("GPS Location")
    data.push(m2Att1)
    
    // Empty row separator
    data.push(js("[]"))
    
    // ========== MEMBER 3: Ahmad (DATA KOSONG) ==========
    val m3Header = js("[]")
    m3Header.push("Ahmad")
    m3Header.push("ahmad@example.com")
    m3Header.push("Member")
    data.push(m3Header)
    
    val m3NoData = js("[]")
    m3NoData.push("No records for this month")
    data.push(m3NoData)
    
    console.log("📊 Data prepared, total rows:", data.length)
    
    // Create worksheet
    val worksheet = js("XLSX.utils.aoa_to_sheet(data)")
    
    // Apply merges
    val merges = js("[]")
    
    // Member 1 header (A1:C1)
    merges.push(js("{s: {r: 0, c: 0}, e: {r: 0, c: 2}}"))
    // Time Off header (A2:A4) - section title merged vertically
    merges.push(js("{s: {r: 1, c: 0}, e: {r: 3, c: 0}}"))
    // Overtime header (A5:A8)
    merges.push(js("{s: {r: 4, c: 0}, e: {r: 7, c: 0}}"))
    // Attendance header (A9:A14)
    merges.push(js("{s: {r: 8, c: 0}, e: {r: 13, c: 0}}"))
    
    // Member 2 header (A16:C16)
    merges.push(js("{s: {r: 15, c: 0}, e: {r: 15, c: 2}}"))
    // Attendance header (A17:A18)
    merges.push(js("{s: {r: 16, c: 0}, e: {r: 17, c: 0}}"))
    
    // Member 3 header (A20:C20)
    merges.push(js("{s: {r: 19, c: 0}, e: {r: 19, c: 2}}"))
    
    worksheet["!merges"] = merges
    
    // Set column widths
    val colWidths = js("[]")
    colWidths.push(js("{wch: 20}")) // Section/Empty
    colWidths.push(js("{wch: 15}")) // Date/Field1
    colWidths.push(js("{wch: 20}")) // Field2
    colWidths.push(js("{wch: 15}")) // Field3
    colWidths.push(js("{wch: 12}")) // Field4
    colWidths.push(js("{wch: 12}")) // Field5
    colWidths.push(js("{wch: 25}")) // Field6
    worksheet["!cols"] = colWidths
    
    // Create workbook
    val workbook = js("XLSX.utils.book_new()")
    js("XLSX.utils.book_append_sheet(workbook, worksheet, '$monthName')")
    
    // Download
    js("XLSX.writeFile(workbook, 'test_dummy_export_v3.xlsx')")
    
    console.log("✅ Test dummy export V3 complete!")
    console.log("========================================")
    
    window.alert(
        "✅ Test dummy export V3 created!\\n\\n" +
        "File: test_dummy_export_v3.xlsx\\n\\n" +
        "Struktur Baru:\\n" +
        "- Member header (merged)\\n" +
        "- Section TIME OFF dengan kolom sendiri\\n" +
        "- Section OVERTIME dengan kolom sendiri\\n" +
        "- Section ATTENDANCE dengan kolom sendiri\\n\\n" +
        "Buka Excel untuk lihat hasilnya!"
    )
    ModalManager.close()
}
